// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"41c4f6a1","453":"25928378","549":"5084e8cc"}[chunkId] + ".chunk.js";
};